import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteConfigContext = createContext({ settings: {}, content: {} });

export function SiteConfigProvider({ children }) {
  const [cfg, setCfg] = useState({ settings: {}, content: {} });

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/public/site`)
      .then(({ data }) => {
        if (mounted) setCfg(data);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return <SiteConfigContext.Provider value={cfg}>{children}</SiteConfigContext.Provider>;
}

// Returns override value if present, else the provided fallback (keeps public site unchanged by default).
export function useContentText(key, fallback) {
  const { content } = useContext(SiteConfigContext);
  return content?.[key] ?? fallback;
}

export function useSettingValue(key, fallback) {
  const { settings } = useContext(SiteConfigContext);
  return settings?.[key] ?? fallback;
}

export const useSiteConfig = () => useContext(SiteConfigContext);
